import { Box, Skeleton, Stack, Switch } from '@mui/material';

import SuiTypography from '@upheal/design-system/components/legacy/Sui/SuiTypography';
import BillingPeriodArrowSvg from '@upheal/design-system/images/billing/billing-period-switch-arrow.svg?react';
import { calculateMinSavingsPercentageForAvailablePlans } from '@upheal/billing/utils/payments';
import { usePlansPricing } from '@upheal/billing/hooks/usePlansPricing';

type BillingPeriodSwitchProps = {
    yearlyChecked: boolean;
    onYearlyCheckedChange: (checked: boolean) => void;
};

const BillingPeriodSwitch = (props: BillingPeriodSwitchProps) => {
    const { yearlyChecked, onYearlyCheckedChange } = props;
    const { currency, pricingData } = usePlansPricing();

    const savingsPercentage =
        calculateMinSavingsPercentageForAvailablePlans(pricingData);

    return (
        <Stack alignItems="center">
            <Box display="flex" alignItems="center" gap="10px">
                <SuiTypography variant="button" color="dark">
                    Monthly
                </SuiTypography>
                <Switch
                    color="success"
                    checked={yearlyChecked}
                    onChange={(e) => {
                        onYearlyCheckedChange(e.target.checked);
                    }}
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track':
                            {
                                backgroundColor: (theme) =>
                                    `${theme.palette.success.main} !important`,
                            },
                    }}
                />
                <SuiTypography variant="button" color="dark">
                    Yearly
                </SuiTypography>
            </Box>
            {currency ? (
                <Box
                    display="flex"
                    gap="10px"
                    justifyContent="flex-end"
                    width="100%"
                    pr={3}
                >
                    <SuiTypography variant="body2" color="success">
                        Save more than <strong>{savingsPercentage}%</strong>
                    </SuiTypography>
                    <Box
                        sx={{
                            color: (theme) => theme.palette.success.main,
                        }}
                    >
                        <BillingPeriodArrowSvg />
                    </Box>
                </Box>
            ) : (
                <Skeleton variant="text" width={80} height={20} />
            )}
        </Stack>
    );
};

export default BillingPeriodSwitch;
